import { Button, Form } from 'antd';
import { useContext } from 'react';
import { ThemeContext } from '../../shared/contexts/Theme.context';

import { colors } from '../../styles/theme';

export default function CustomButton(props) {
  const {
    htmlType,
    text,
    onClick,
    form,
    disabled,
    loading = false,
    secondary = false,
    small = false,
    icon,
  } = props;

  const { state: theme } = useContext(ThemeContext);

  return (
    <>
      <Form.Item>
        <Button
          disabled={disabled}
          className={`custom-btn ${secondary ? 'secondary' : ''}`}
          htmlType={htmlType}
          onClick={onClick}
          form={form}
          loading={loading}
          style={small ? smallStyle : null}
          icon={icon}
        >
          {text}
        </Button>
      </Form.Item>

      <style jsx global>{`
        .ant-btn.custom-btn {
          background: ${theme.secondaryColor};
          border: 2px solid ${theme.secondaryColor};
          border-radius: 30px;
          color: white;
          font-size: 20px;
          padding: 10px 50px;
          height: auto;
          width: 100%;
        }
        .ant-layout-footer .ant-btn.custom-btn {
          min-width: 50vw;
        }
        .ant-btn.custom-btn[disabled] {
          border: 2px solid ${colors.grey};
          border-radius: 30px;
          background: ${colors.grey};
          color: white;
        }
        .ant-btn.custom-btn.secondary {
          background: ${theme.secondaryColor};
          border: 2px solid white;
          border-radius: 30px;
          color: white;
          font-size: 20px;
          padding: 10px 50px;
          height: auto;
          width: 100%;
        }
        footer .ant-form-item {
          margin-bottom: 0;
        }
      `}</style>
    </>
  );
}

const smallStyle = {
  paddingTop: 10,
  paddingBottom: 10,
  paddingLeft: 28,
  paddingRight: 28,
  fontSize: 14,
};
